/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { ResultContainerModule } from './result-container.module';
export { ResultContainerComponent } from './result-container.component';